<ion-header>
  <ion-toolbar mode="md">
    <ion-title>Asistence: {{ assistance.client?.user?.firstName }} {{ assistance.client?.user?.lastName }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- FAB -->
  <!-- TODO LATER extract to separate component ideally-->
  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ng-container *ngIf="fab.states[RoleAssistantFabState.working]">
      <ion-button class="fab" color="secondary">
        <ion-spinner name="bubbles"></ion-spinner>
      </ion-button>
    </ng-container>

    <ng-container *ngIf="fab.states[RoleAssistantFabState.assistanceReadyToBeConfirmed]">
      <ion-button class="fab" (click)="confirmAssistance()" color="secondary">
        <ion-icon name="checkmark"></ion-icon>
        <span>Potvrdit asistenci</span>
      </ion-button>
    </ng-container>

    <ng-container *ngIf="fab.states[RoleAssistantFabState.assistanceReadyToStart]">
      <ion-button class="fab" (click)="startAssistance()" color="secondary">
        <ion-icon name="play"></ion-icon>
        <span>Začít asistenci</span>
      </ion-button>
    </ng-container>

    <ng-container *ngIf="fab.states[RoleAssistantFabState.assistanceReadyToEnd]">
      <ion-button class="fab" (click)="askEndAssistance()" color="secondary">
        <ion-icon name="stop"></ion-icon>
        <span>Ukončit asistenci</span>
      </ion-button>
    </ng-container>

    <ng-container *ngIf="fab.states[RoleAssistantFabState.assistanceFinished] && !assistance.nonClientWork">
      <ion-button class="fab" (click)="openFeedbackModal()" color="secondary">
        <ion-icon name="chatbubbles-outline"></ion-icon>
        <span>Zpětná vazba koordinátorům</span>
      </ion-button>
    </ng-container>
  </ion-fab>

  <ng-template #fab2>fab2</ng-template>

  <!-- FAB END -->

  <ion-list id="list" lines="full" class="accomodate-toolbar-above ion-no-margin ion-no-padding">
    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col size="12">
          <ion-item>
            <ion-label>Plánovaný čas asistence</ion-label>
            <div slot="end" id="plannedDate">
              <app-date-range-view
                [startDate]="assistance.plannedFrom"
                [endDate]="assistance.plannedTo"
              ></app-date-range-view>
            </div>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="assistance.realizedFrom">
        <ion-col size="12">
          <ion-item>
            <ion-label>Skutečný čas asistence</ion-label>
            <div slot="end" id="realizedDate">
              <app-date-range-view
                [startDate]="assistance.realizedFrom"
                [endDate]="assistance.realizedTo"
              ></app-date-range-view>
            </div>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <ion-item>
            <ion-label>Stav</ion-label>
            <span [style.backgroundColor]="assignment?.status?.color" class="status-colored">
              {{ assignment?.status?.humanReadableName }}
            </span>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-item>
        <ion-label>Popis</ion-label>
        {{ assistance.shortDescription }}
      </ion-item>

      <ion-item
        *ngIf="assignment?.status?.isAtLeast(CONFIRMED) && !assistance.nonClientWork"
        (click)="openFeedbackModal()"
      >
        <ion-label position="fixed">Moje zpětná vazba</ion-label>
        <span ellipsis [ellipsis-content]="assignment.assistantFeedback" id="feedback-content"></span>
        <ion-icon slot="end" name="create-outline" color="primary"></ion-icon>
      </ion-item>

      <ion-row>
        <ion-col size="12">
          <ion-item>
            <ion-label>Kontakt na klienta</ion-label>
            {{ assistance.client | getPrimaryContact }}
          </ion-item>

          <ion-item>
            <ion-label>Koordinátor klienta</ion-label>
            {{ (keyCoordinator$ | async)?.fullName() }}
          </ion-item>

          <ion-item-divider>
            <ion-label>Adresa</ion-label>
          </ion-item-divider>

          <ion-item>
            <ion-label>Začátek</ion-label>
            {{ assistance.addressStart }}
          </ion-item>
          <ion-item>
            <ion-label>Konec</ion-label>
            {{ assistance.addressEnd }}
          </ion-item>

          <ion-item-divider>
            <ion-label>Detailní popis výkonu</ion-label>
          </ion-item-divider>

          <ion-item>
            <!-- <ion-label>Detailní popis výkonu</ion-label> -->
            <div id="detailedDescription" [innerHTML]="assistance.detailedDescription | bypassHtmlSanitizer"></div>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-list>
</ion-content>
